import React, { useState, useEffect } from 'react';
import { Card, CardBody, Row, Col, Button } from 'reactstrap';
import history from '../../../history';
import Spinner from 'react-bootstrap/Spinner';
import TableComplaintsAndClaims from './TableComplaintsAndClaims';
import TableComplaintsAndClaimsActions from './TableComplaintsAndClaimsActions';

const DataComplaintsAndClaims = ({ }) => {

    const [dataClaims, setDataClaims] = useState([]);
    const [loading, setLoading] = useState(false);

    const getComplaintsAndClaims = async () => {
        setLoading(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'quejas-reclamos/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Ha ocurrido un error creando la Queja');
            }
        }).then((data) => {
            setDataClaims(data);
            setLoading(false);
        }).catch(err => {
            setDataClaims([]);
            setLoading(false);
            console.log(err);
        });
    }

    useEffect(() => {
        getComplaintsAndClaims();
    }, []);

    return (
        <Card>
            <CardBody>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: 30 }}>
                    <Button
                        style={{ marginRight: 10, marginTop: 10 }}
                        color="primary"
                        size="sm"
                        id="searchBtn"
                        onClick={() => {
                            history.push({
                                pathname: process.env.PUBLIC_URL + '/assitencial/form-complaints-claims',
                                state: { complaints_claim: null }
                            });
                        }}
                    >
                        Agregar Queja
                    </Button>
                </div>
                <br />

                {loading == false ?
                    <>
                        {
                            dataClaims.length > 0 ? <TableComplaintsAndClaims reactTableData={dataClaims} ReactTableActions={TableComplaintsAndClaimsActions} Callback={() => getComplaintsAndClaims()} /> : null
                        }
                    </> :
                    <div className="text-center">
                        <Spinner animation="border" variant="success" />
                    </div>}

            </CardBody>
        </Card>)
}

export default DataComplaintsAndClaims;